// Randomize Products
function shuffleProducts() {
  const productGrid = document.querySelector('.product-grid'); // Adjust selector
  const products = Array.from(productGrid.children);
  
  // Shuffle array
  for (let i = products.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [products[i], products[j]] = [products[j], products[i]];
  }
  
  // Re-append in new order
  products.forEach(product => productGrid.appendChild(product));
}

// Run on page load
document.addEventListener('DOMContentLoaded', shuffleProducts);